import { useSearchParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { usePublicData } from "@/lib/publicData";
import { PageHero, Container } from "@/components/public/parts";
import { Field, Success, useSubmit, api, Input, Textarea, Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Loader2 } from "./formkit";
import { useState } from "react";

export default function RequestServices() {
  const data = usePublicData();
  const [params] = useSearchParams();
  const services = (data?.services || []).map((s) => s.name);
  const [form, setForm] = useState({ service: params.get("service") || "" });
  const { loading, result, submit } = useSubmit();
  const set = (k, v) => setForm({ ...form, [k]: v });

  const onSubmit = (e) => {
    e.preventDefault();
    submit(async () => (await api.post("/public/request-services", form)).data);
  };

  return (
    <>
      <Seo title="Request Services | Love For Mankind" description="Request compassionate disability and community support services from Love For Mankind across Ohio." path="/request-services" />
      <PageHero eyebrow="Get Started" title="Request Services" sub="Tell us a little about your needs and our team will reach out to guide you." breadcrumbs={[{ label: "Home", to: "/" }, { label: "Request Services" }]} />
      <Container className="py-16 lg:py-20 max-w-2xl">
        {result ? <Success refNo={result.reference_no} message={result.message} /> : (
          <form onSubmit={onSubmit} className="space-y-5 rounded-2xl border border-border bg-card p-7 lg:p-9" data-testid="request-form">
            <div className="grid sm:grid-cols-2 gap-5">
              <Field label="Full Name" required><Input required value={form.name || ""} onChange={(e) => set("name", e.target.value)} data-testid="rs-name" /></Field>
              <Field label="Email" required><Input type="email" required value={form.email || ""} onChange={(e) => set("email", e.target.value)} data-testid="rs-email" /></Field>
              <Field label="Phone"><Input value={form.phone || ""} onChange={(e) => set("phone", e.target.value)} data-testid="rs-phone" /></Field>
              <Field label="Location / City"><Input value={form.location || ""} onChange={(e) => set("location", e.target.value)} data-testid="rs-location" /></Field>
              <Field label="Service Needed">
                <Select value={form.service} onValueChange={(v) => set("service", v)}>
                  <SelectTrigger data-testid="rs-service"><SelectValue placeholder="Select a service" /></SelectTrigger>
                  <SelectContent>{services.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
              </Field>
              <Field label="Preferred Contact">
                <Select value={form.preferred_contact || ""} onValueChange={(v) => set("preferred_contact", v)}>
                  <SelectTrigger data-testid="rs-contact"><SelectValue placeholder="Phone or Email" /></SelectTrigger>
                  <SelectContent><SelectItem value="Phone">Phone</SelectItem><SelectItem value="Email">Email</SelectItem><SelectItem value="Text">Text</SelectItem></SelectContent>
                </Select>
              </Field>
            </div>
            <Field label="Message"><Textarea value={form.message || ""} onChange={(e) => set("message", e.target.value)} data-testid="rs-message" /></Field>
            <Button type="submit" className="rounded-full w-full h-13 min-h-[52px]" disabled={loading} data-testid="rs-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Submit Request"}</Button>
          </form>
        )}
      </Container>
    </>
  );
}
